export const costTypes = {
    SET_COST_TYPE: 'SET_COST_TYPE',
    SET_COST_DATE: 'SET_COST_DATE'
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/actions/types/cost.types.js